export default __webpack_public_path__ + "static/media/property-logo.ef16bbed.png";